import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { LoadingGif } from '../Shared/CommonStyles';

interface SlideshowThumbnailProps {
	images: string[];
	interval?: number; // milliseconds
    isLoading?: boolean;
}

const Container = styled.div`
	width: 100%;
	aspect-ratio: 4 / 3;
	position: relative;
	background-color: #eee;
	overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
`;

const Slide = styled.div<{ $imageUrl: string; $active: boolean }>`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-image: url(${(props) => props.$imageUrl});
	background-size: cover;
	background-position: center;
	opacity: ${(props) => (props.$active ? 1 : 0)};
	transition: opacity 1s ease-in-out;
	z-index: ${(props) => (props.$active ? 1 : 0)};
`;

const SlideshowThumbnail: React.FC<SlideshowThumbnailProps> = ({
        images,
        isLoading,
        // interval prop is ignored in favor of random internal logic
}) => {
        const [currentIndex, setCurrentIndex] = useState(0);

        useEffect(() => {
                if (images.length <= 1) return;

                let timeoutId: NodeJS.Timeout;

                const scheduleNextSlide = () => {
                        // Random interval between 5000ms and 10000ms
                        const randomInterval = Math.floor(Math.random() * 5001) + 5000;
                        
                        timeoutId = setTimeout(() => {
                                setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
                                scheduleNextSlide(); // Schedule the next one recursively
                        }, randomInterval);
                };

                scheduleNextSlide();

                return () => clearTimeout(timeoutId);
        }, [images.length]);

        if (isLoading) {
            return (
                <Container>
                    <LoadingGif size="large" />
                </Container>
            );
        }

        if (!images || images.length === 0) {		return (
			<Container>
				<Slide
					$imageUrl="https://placehold.co/400x300/eee/ccc?text=No+Image"
					$active={true}
				/>
			</Container>
		);
	}

	return (
		<Container>
			{images.map((img, index) => (
				<Slide key={index} $imageUrl={img} $active={index === currentIndex} />
			))}
		</Container>
	);
};

export default SlideshowThumbnail;
